import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { Table, InputSearchBase, TabHeader } from '@/presentation/components';
import Styles from './transaction-history-styles.scss';
import useTransactionTable from '@/presentation/pages/my-wallet/checking-account/hooks/useTransactionTable';
import { transactionTablePocketState, transactionTableState } from '@/presentation/pages/my-wallet/checking-account/components/atoms';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
import { debounce } from 'lodash';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
const TransactionHistory = ({ manageVirtualTransactions, reloadTransactions }) => {
    const [state, setState] = useRecoilState(transactionTableState);
    const { pockets } = useStudentAccounts(false);
    const { columns, columnsWithoutSort, getTransactionsPaginated, renderCellByType } = useTransactionTable({
        mainTableState: transactionTablePocketState,
        manageVirtualTransactions,
        virtualAccountIds: pockets.map(pocket => pocket.id)
    });
    const handleOnSearch = debounce((event) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { filters: Object.assign(Object.assign({}, prev.filters), { input: event.target.value }) });
        });
    }, 500);
    useEffect(() => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { reloadTransactions: !prev.reloadTransactions });
        });
    }, [reloadTransactions]);
    return (React.createElement("div", { className: Styles.transactionHistoryContainer },
        React.createElement(TabHeader, { title: "Transaction History" },
            React.createElement("div", { className: Styles.wrapBtns },
                React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                    React.createElement(InputSearchBase, { loading: state.isTableLoading, placeholder: "Search...", onChange: handleOnSearch, customStyle: Styles.customStyleSearch, notInitialFocus: true })))),
        React.createElement(Table, { columns: columns, data: state.transactions.data, 
            // dataNotFound={state.dataNotFound}
            DataNotFoundComponent: () => {
                return React.createElement(DataNotFoundComp, null);
            }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                total: state.transactions.total,
                page: state.transactions.page,
                count: state.transactions.count,
                pageCount: state.transactions.pageCount
            }, fetchData: (pagination, sort) => {
                getTransactionsPaginated(state.filters, pagination, sort);
            }, filters: state.filters, loading: state.isTableLoading })));
};
const DataNotFoundComp = () => {
    // const [state, setState] = useRecoilState(manageStudentsAtom);
    return (React.createElement(TableNotFound
    /*
    onClick={() => {
      setState(prev => {
        return {
          ...prev,
          filters: {
            input: '',
            deleted: false
          },
          dataNotFound: false
        };
      });
    }}
    term={state.filters.input !== '' ? state.filters.input : null}
    */
    , { 
        /*
        onClick={() => {
          setState(prev => {
            return {
              ...prev,
              filters: {
                input: '',
                deleted: false
              },
              dataNotFound: false
            };
          });
        }}
        term={state.filters.input !== '' ? state.filters.input : null}
        */
        onClick: () => console.log('0'), term: "NOT FOUND" }));
};
export default TransactionHistory;
